/* eslint-disable react/prop-types */
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import FormField from "components/FormField";

function Form({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { domain, apiKey, url } = formField;
  const { domain: domainV = "", apiKey: apiKeyV = "", url: urlV = "" } = values;

  return (
    <MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormField
            type={url.type}
            label={url.label}
            name={url.name}
            value={urlV}
            placeholder={url.placeholder}
            error={errors.url && touched.url}
            success={urlV.length > 0 && !errors.url}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            type={domain.type}
            label={domain.label}
            name={domain.name}
            value={domainV}
            placeholder={domain.placeholder}
            error={errors.domain && touched.domain}
            success={domainV.length > 0 && !errors.domain}
          />
        </Grid>

        <Grid item xs={12}>
          <FormField
            type={apiKey.type}
            label={apiKey.label}
            name={apiKey.name}
            value={apiKeyV}
            placeholder={apiKey.placeholder}
            error={errors.apiKey && touched.apiKey}
            success={apiKeyV.length > 0 && !errors.apiKey}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Form;
